module.exports = __webpack_public_path__ + "img/template-design.ba5ed3be.png";